export const getAuthStorageToken = (): string | null => {
	const storage = JSON.parse(localStorage.getItem('auth') || '{}');
	return storage?.state?.jwtToken?.access_token || null;
};

export const checkMessagesHash = (): boolean => sessionStorage.getItem('messagesHash') === import.meta.env.VITE_TICKETS_HASH;
